import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { PlacesResponse, PlaceResponse, PlaceWithState } from '@/types/api';

export function usePlaces(category?: string) {
  const [places, setPlaces] = useState<PlaceWithState[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setPlaces(null);
    setError(null);
    const qs = category ? `?category=${encodeURIComponent(category)}` : '';
    api
      .get<PlacesResponse>(`/places${qs}`)
      .then((res) => !cancelled && setPlaces(res.places))
      .catch((err) => !cancelled && setError(err.message ?? 'Could not load places.'));
    return () => {
      cancelled = true;
    };
  }, [category]);

  return { places, error, loading: places === null && !error };
}

export function usePlace(slug: string | undefined) {
  const [place, setPlace] = useState<PlaceWithState | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    api
      .get<PlaceResponse>(`/places/${slug}`)
      .then((res) => !cancelled && setPlace(res.place))
      .catch((err) => !cancelled && setError(err.message ?? 'Place not found.'))
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [slug]);

  return { place, error, loading };
}
